import { api } from './client';
import type {
  ComplianceRule,
  ComplianceRuleCreateInput,
  ComplianceRuleUpdateInput,
  Page,
  RecomputeReport,
  UUID,
} from './types';

export interface ComplianceRulesListParams {
  rule_key?: string;
  include_deleted?: boolean;
  limit?: number;
  offset?: number;
}

function qs(params: object): string {
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null && v !== '') usp.set(k, String(v));
  }
  return usp.toString() ? `?${usp}` : '';
}

export const complianceRulesApi = {
  list:    (p: ComplianceRulesListParams = {}) =>
    api.get<Page<ComplianceRule>>(`/compliance-rules${qs(p)}`),
  get:     (id: UUID) =>
    api.get<ComplianceRule>(`/compliance-rules/${id}`),
  create:  (payload: ComplianceRuleCreateInput) =>
    api.post<RecomputeReport>('/compliance-rules', payload),
  update:  (id: UUID, payload: ComplianceRuleUpdateInput) =>
    api.patch<RecomputeReport>(`/compliance-rules/${id}`, payload),
  delete:  (id: UUID) =>
    api.delete<RecomputeReport>(`/compliance-rules/${id}`),
  restore: (id: UUID) =>
    api.post<RecomputeReport>(`/compliance-rules/${id}/restore`, {}),
};
